/**
 * Stacking budget for in-scene DOM labels (drei `<Html>`): forklift labels,
 * sensor billboards, aisle KPI badges.
 *
 * ADR 214: these used `[10, 0]`, and drei stamps a z-index from that range onto
 * a wrapper inside `.canvasWrap`. Since the canvas wrapper and the /live side
 * panels are siblings with `z-index: auto` in the SAME stacking context, a label
 * at z-index 8 painted straight over the panels. Capping the range under the
 * panels' own z-index (`--z-panel`, LivePage.module.css) makes the scene layer
 * structurally incapable of covering the chrome — depth ordering AMONG labels is
 * preserved, since drei only needs a range to interpolate within.
 */
export const LABEL_Z_RANGE: [number, number] = [2, 0];
